import { Icon, IconsEnum } from 'components/Icons';

import { AnchorLink } from 'components/anchorLink';
import { IppicaHeaderDetailsBox } from '../ippicaHeaderDetailsBox';
import { IppicaHeaderNumeroCorsa } from '../ippicaHeaderNumeroCorsa';
import { ScommesseTableWidget } from 'components/scommesseTable/scommesseTableWidget';
import { Widget } from 'features/sport/components/sportWidgetList/SportWidgetList';
import dynamic from 'next/dynamic';
import { ippicaToggleNavMobile } from 'features/ippica/ippicaSlice';
import styles from './IppicaHeaderSticky.module.scss';
import { useDispatch } from 'react-redux';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { IppicaBroadcastBox } from '../ippicaBroadcast/ippicaBroadcastBox';
import { BroadcastEnum } from 'features/ippica/types';
import { useTypedSelector } from 'lib/centralStore';

export const DynamicIppicaHeaderSticky = dynamic(() =>
  import('features/ippica/components/ippicaHeaderSticky').then((mod) => mod.IppicaHeaderSticky)
);

export type IppicaHeaderStickyProps = {
  linkBack: string;
  widget?: Widget[];
};

export const IppicaHeaderSticky = ({ linkBack, widget }: IppicaHeaderStickyProps) => {
  const { urlBroadcast, broadcastNeedsLogIn } = useTypedSelector((state) => state.ippica.ippicaDetailRace! ?? {});

  const dispatch = useDispatch();
  const labelCambia = useGetLabelByKey('cambia')!;
  const labelCorsa = useGetLabelByKey('corsa')!;
  return (
    <div className={styles.container} suppressHydrationWarning>
      <AnchorLink href={linkBack} className={styles.linkBack}>
        <Icon iconId={IconsEnum.ARROW} className={styles.iconBack} color="var(--color-on-bg-primary)" />
      </AnchorLink>
      <IppicaHeaderNumeroCorsa />

      <button type="button" className={styles.button} onClick={() => dispatch(ippicaToggleNavMobile(true))}>
        <IppicaHeaderDetailsBox />
        <div className={styles.changeSelection}>
          <span>{labelCambia}</span>
          <span>{labelCorsa}</span>
        </div>
      </button>
      {urlBroadcast && (
        <IppicaBroadcastBox
          name={''}
          type={BroadcastEnum.TV}
          hasButtonOnIcon
          url={urlBroadcast}
          logged={broadcastNeedsLogIn}
        />
      )}
      {widget && widget.length > 0 && <ScommesseTableWidget items={widget} className={styles.widgetList} />}
    </div>
  );
};
